import React, { useRef } from 'react';
var VeltNotificationsPanelHeaderTabDocuments = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-header-tab-documents", { ref: ref }, children));
};
export default VeltNotificationsPanelHeaderTabDocuments;
